module.exports = __webpack_public_path__ + "static/media/DjangoCertificate.29040c04.jpg";